import React from 'react'
import styles from './Spacer.scss'

/**
 * 責務: 余白の表示
 * @param { number } size 余白のサイズ px
 * @param { 'x' | 'y' } direction 余白の向き
 * @returns { JSX.Element } セクションコンポーネントを返す
 */

export const Spacer = ({
  size,
  direction = 'y'
}) => {
  const className = styles[`spacer-${direction}-${size}`]
  return <div className={className} />
}
